export const timeStamp24hrComparision = (lastChatTimestamp) => {
  try {
    // Ensure lastChatTimestamp is a valid number
    const timestamp = Number(lastChatTimestamp);
    if (isNaN(timestamp) || timestamp <= 0) {
      return false;
    }

    // Get current time in seconds
    const currentTime = Math.floor(Date.now() / 1000);
    // console.log("currentTime - timestamp", currentTime - timestamp);

    // Compare timestamps for 24 hours
    return currentTime - timestamp <= 86400;
  } catch (error) {
    console.error(
      "timeStamp24hrComparision catch error",
      error?.message || error
    );
    return false;
  }
};
